import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { ImageMetadata } from './types';

export enum ImageAttrs {
  ALT_DESC = 'alt',
  BORDER = 'border',
  HEIGHT = 'height',
  SOURCE = 'src',
  STYLES = 'style',
  WIDTH = 'width',
}

export const imageAttrStateDefault = {
  [ImageAttrs.ALT_DESC]: '',
  [ImageAttrs.BORDER]: '',
  [ImageAttrs.HEIGHT]: '',
  [ImageAttrs.SOURCE]: '',
  [ImageAttrs.STYLES]: '',
  [ImageAttrs.WIDTH]: '',
};

export enum ImageAttrBatch {
  SET_NEW = 'new',
  UPDATE_BATCH = 'update',
}

export enum LinkAttrs {
  HREF = 'href',
  STYLES = 'style',
}

export const linkAttrStateDefault = {
  [LinkAttrs.HREF]: '',
  [LinkAttrs.STYLES]: '',
};

export enum LinkAttrBatch {
  SET_NEW = 'new',
  UPDATE_BATCH = 'update',
}

export enum MovableInkModal {
  Add = 'add',
  Delete = 'delete',
}

export enum PanelView {
  Detail = 'detail',
  List = 'list',
}

// https://support.movableink.com/hc/en-us/articles/360007488334-Movable-Ink-Content-API#MovableInkContentAPI-/blocks
export enum SortableField {
  CreatedAt = 'created_at',
  Name = 'name',
  UpdatedAt = 'updated_at',
}

// https://support.movableink.com/hc/en-us/articles/360007488334-Movable-Ink-Content-API#MovableInkContentAPI-/blocks
export const defaults = {
  pageSize: 30,
  sortBy: SortableField.Name,
  sortDirection: SORT_DIRECTIONS.DESCENDING,
};

// the authUrl is the endpoint where a user authenticaes their Movable Ink account for use with
// Iterable (a successful authentication request returns a token that can be used in future requests)
export const authUrl = 'https://app.movableink.com/oauth/authorize';

// hostNames are a list of possible host names for MI content (the src of the image) to identify a
// given image a "Movable Ink" vs Creative Library or external
export const hostNames = ['www.ink1000.com'];

// the route in Iterable to redirect to following a successful authentication
export const integrationsRedirectPath = '/integrations/movableInkIntegration';

// The Client ID provided to you by MovableInk. This identifies that your application is authorized
// to request resources on behalf of users. (AKA "Application ID")
export const integrationsClientId = 'I66gKJ4zg95dnH4XN7gy_0i2qqyb51iaVE0Voj-LNHQ';

export const INTEGRATION_DOC = 'https://support.iterable.com/hc/en-us/articles/360016366711';

export const defaultImgMetadata = {} as ImageMetadata;
